import { Form } from "components/ResumeForm/Form";
import RichEditor from "./Form/QuillEditor";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { changeCustom, selectCustom } from "lib/redux/resumeSlice";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const CustomForm = () => {
  const custom = useAppSelector(selectCustom);
  const dispatch = useAppDispatch();
  const { descriptions } = custom;
  const form = "custom";

  const handleCustomChange = (field: "descriptions", value: string[]) => {
    dispatch(changeCustom({ field, value }));
  };

  return (
    <Form form={form}>
      <div className="col-span-full grid grid-cols-6 gap-3">
        <div className="relative col-span-full">
          {/* <RichEditor
            name="descriptions"
            value={descriptions}
            onChange={handleCustomChange}
            labelClassName="col-span-full"
            placeholder="Fluent in tech speak, coffee enthusiast, perpetual learner."
          /> */}
          <RichEditorWithSuggestions
            name="descriptions"
            value={descriptions}
            onChange={handleCustomChange}
            placeholder="Fluent in tech speak, coffee enthusiast, perpetual learner."
            section="custom"
          />
        </div>
      </div>
    </Form>
  );
};
